module.exports = __webpack_public_path__ + "img/menu.ba815760.svg";